/** User-safe copy when an upstream (API / GCS) failure should not surface raw XML or infra codes. */
export const UPSTREAM_UNAVAILABLE_MESSAGE =
  'This is temporarily unavailable. Please try again in a few minutes.';

export const WAITLIST_UNAVAILABLE_MESSAGE =
  'We could not add you to the waitlist right now. Please try again shortly.';

/** GCS and similar gateways often return XML like `<Error><Code>UserProjectAccountProblem</Code>…`. */
export function isInfrastructureXmlErrorBody(raw: string): boolean {
  const t = raw.trim();
  if (!t.startsWith('<')) return false;
  return (
    t.includes('<Error>') ||
    t.includes('UserProjectAccountProblem') ||
    t.includes('BillingAccount') ||
    t.includes('NoSuchBucket') ||
    t.includes('AccessDenied') ||
    t.includes('AccountProblem')
  );
}

export function isJsonContentType(contentType: string | null): boolean {
  if (!contentType) return false;
  const base = contentType.split(';')[0]?.trim().toLowerCase() ?? '';
  return base === 'application/json' || base.endsWith('+json');
}

export function userMessageForUpstreamBody(
  raw: string,
  fallback = UPSTREAM_UNAVAILABLE_MESSAGE
): string {
  if (isInfrastructureXmlErrorBody(raw)) return fallback;
  if (raw.trim().startsWith('<')) return fallback;
  return fallback;
}

export type ParsedJsonBody = { ok: true; json: unknown } | { ok: false; userMessage: string };

/** Parse JSON bodies from marketing API calls; never expose raw XML to the UI. */
export function parseMarketingApiJsonBody(
  raw: string,
  fallback = UPSTREAM_UNAVAILABLE_MESSAGE
): ParsedJsonBody {
  if (!raw.trim()) {
    return { ok: true, json: {} };
  }
  if (isInfrastructureXmlErrorBody(raw) || raw.trim().startsWith('<')) {
    return { ok: false, userMessage: userMessageForUpstreamBody(raw, fallback) };
  }
  try {
    return { ok: true, json: JSON.parse(raw) as unknown };
  } catch {
    return { ok: false, userMessage: fallback };
  }
}
